const Colors = {
  primaryColor: '#0092ae',
  secondaryColor: '#95bd51',
  newSecondaryColor: '#9DBC60',
  newLightGreenSecondaryColor: '#C3D3A5',
  tertiaryColor: '#535862',
  tertiaryHover: '#414651',
  // GreenColor: '#22312B',
  GreenColor: '#1e322b',
  black: '#000',
  white: '#fff',
  grey: '#e5e5e5',
  steel: '#6d8083',
  red: '#ff0000',
  transparent: 'transparent',
  hoverBackground: '#fafafa',

  greyV2: "#A4A7AE",
  greenText: "#3F621A",
  brightGrey: "#E9EAEB",
};
export default Colors;
